import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=5a6bcd88&scoped=true&lang=pug&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&id=5a6bcd88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6bcd88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5a6bcd88', component.options)
    } else {
      api.reload('5a6bcd88', component.options)
    }
    module.hot.accept("./Image.vue?vue&type=template&id=5a6bcd88&scoped=true&lang=pug&", function () {
      api.rerender('5a6bcd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview_area/built-in component/Image.vue"
export default component.exports